// export const BASE_URL ="http://localhost:9000"
export const BASE_URL ="https://nodejs.talhajeweller.pk/echonotes"
// export const BASE_URL ="http://localhost:9000"
